export const planningProcessTitle = name => String(name || '').trim().toLocaleLowerCase('es') === 'corte' ? 'Tejido/Corte' : name;

export function orderPlanningColumns(columns, processes) {
  const byId = new Map(processes.map(process => [process.id, process]));
  const order = column => {
    const process = byId.get(column.processId);
    return process?.planning_order == null ? Infinity : Number(process.planning_order);
  };
  // Stable sorting keeps the existing process/supplier order for ties.
  return [...columns].sort((a, b) => (order(a) - order(b)) || 0);
}
